export default function StreakDisplay({ currentStreak, longestStreak, totalEntries }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {/* Current Streak */}
      <div 
        data-testid="current-streak-card"
        className="bg-gradient-to-br from-orange-100 to-red-100 rounded-2xl p-6 shadow-lg hover-lift animate-scale-in"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 mb-1">Mevcut Seri</p>
            <p className="text-4xl font-bold text-orange-600">{currentStreak}</p>
            <p className="text-xs text-gray-500 mt-1">ardışık gün</p>
          </div>
          <span className={`text-5xl ${currentStreak > 0 ? 'fire-effect' : ''}`}>🔥</span>
        </div>
        {currentStreak >= 7 && (
          <div className="mt-3 text-xs text-orange-700 font-semibold bg-orange-200 px-3 py-1 rounded-full inline-block animate-bounce-slow">
            Harika gidiyorsun! 🎉
          </div>
        )}
      </div>

      {/* Longest Streak */}
      <div 
        data-testid="longest-streak-card"
        className="bg-gradient-to-br from-yellow-100 to-amber-100 rounded-2xl p-6 shadow-lg hover-lift animate-scale-in"
        style={{ animationDelay: '0.1s' }}
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 mb-1">En Uzun Seri</p>
            <p className="text-4xl font-bold text-amber-600">{longestStreak}</p>
            <p className="text-xs text-gray-500 mt-1">ardışık gün</p>
          </div>
          <span className="text-5xl animate-bounce-slow">🏆</span>
        </div>
      </div>

      {/* Total Entries */}
      <div 
        data-testid="total-entries-card"
        className="bg-gradient-to-br from-green-100 to-emerald-100 rounded-2xl p-6 shadow-lg hover-lift animate-scale-in"
        style={{ animationDelay: '0.2s' }}
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 mb-1">Toplam Kayıt</p>
            <p className="text-4xl font-bold text-green-600">{totalEntries}</p>
            <p className="text-xs text-gray-500 mt-1">ruh hali kaydı</p>
          </div>
          <span className="text-5xl animate-float">📊</span>
        </div>
      </div>
    </div>
  );
}